<template>
  <v-dialog
    v-model="showDialog"
    max-width="900"
    @click:outside="cancelDialog"
    content-class="connect-dialog"
  >
    <v-card v-if="details.OS === 'Linux'">
      <v-card-title>
        <h3>Connect</h3>
      </v-card-title>

      <v-card-text v-if="!details.ConnectedId" class="command">
        <span>click to copy</span>
        <p @click="copyCommand(command)">{{ command }}</p>
        <!-- <v-textarea
					class="dupa"
          filled
          :value="command"
					disabled
					full-width
					no-resize
					hide-details
        ></v-textarea>-->
      </v-card-text>

      <v-card-text v-else class="command">
        <span>click to copy</span>
        <p v-for="c in command" :key="c" @click="copyCommand(c)">{{ c }}</p>
      </v-card-text>
      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <h3>Connect</h3>
      </v-card-title>
      <v-select
        :items="environmentNames"
        v-model="selectedEnvironment"
        label="Select environment"
        outlined
        class="pa-5 pl-12 pr-12"
      ></v-select>
      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Close</v-btn>
        <v-btn
          text
          :download="`${selectedEnvironment}.rdp`"
          :href="`data:application/octet-stream;charset=utf-8;base64,${rdp}`"
          :class="{ disabled: details.Status !== 'running' }"
          class="text-uppercase connect"
          @click="prepareRDP(selectedEnvironment)"
        >
          Connect
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    selectedEnvironment: "",
    environmentNames: [],
    rdp: "",
  }),
  computed: {
    command() {
      let command;

      if (!this.details.ConnectedId) {
        command = `ssh ${this.OSUsername}@ssh.${this.FQDN} -i <path-to-your-private-key-file>`;
      } else {
        command = this.details.environments.map(
          (env) =>
            `ssh ${env.OSUsername}@ssh.${env.FQDN} -i <path-to-your-private-key-file>`
        );
      }
      return command;
    },
    showDialog: {
      get() {
        return this.showConnectDialog;
      },
      set(value) {
        this.$emit("update:showConnectDialog", value);
      },
    },
  },
  props: ["showConnectDialog", "keyPairName", "FQDN", "OSUsername", "details"],
  watch: {
    async showConnectDialog() {
      const { showConnectDialog } = this;

      if (showConnectDialog) {
        console.log("test");
        await this.whitelistIP();
      }
    },
  },
  methods: {
    ...mapActions(["showSnackbar", "addWhitelistedIP"]),
    cancelDialog() {
      this.showDialog = false;
    },
    copyCommand(command) {
      const textArea = document.createElement("textarea");
      textArea.value = command;
      document.body.appendChild(textArea);
      textArea.select();
      textArea.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      textArea.remove();
      this.showSnackbar("Command has been copied!");
    },
    async whitelistIP() {
      if (!this.details) {
        const environmentId = this.$route.params.id;
        await this.addWhitelistedIP(environmentId);
      } else {
        if (this.details.environments) {
          await Promise.all(
            this.details.environments.map(
              async (env) => await this.addWhitelistedIP(env.EnvironmentId)
            )
          );
        } else {
          await this.addWhitelistedIP(this.details.Id)
        }
      }
    },
    encodeRDPFile(FQDN) {
      let rdp = `
      auto connect:i:1
      full address:s:rdp.${FQDN}
      username:s:Administrator
      `;

      const encoded = window.btoa(rdp);

      this.rdp = encoded;
    },
    prepareRDP(selectedEnvironment) {
      const { FQDN } = this.details.environments.find((env) =>
        env.FQDN.includes(selectedEnvironment)
      );
      this.encodeRDPFile(FQDN);
      this.cancelDialog();
    },
  },
  created() {
    if (this.details.ConnectedId) {
      this.environmentNames = this.details.environments.map(
        (env) => env.FQDN.split(".")[0]
      );
      this.selectedEnvironment = this.environmentNames[0];
    }
  },
};
</script>

<style scoped>
.connect-dialog h3,
p {
  font-family: "Montserrat";
  text-align: center;
}

.connect-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.connect-dialog p {
  font-weight: 500;
}

.connect-dialog .buttons {
  padding-bottom: 60px;
}

.buttons {
  font: 12px/15px "Montserrat";
}

.command {
  text-align: center;
}

.command p {
  background: #e1e4ea;
  padding: 15px;
  margin-top: 10px;
}
</style>
